module.exports = __webpack_public_path__ + "img/main-bg.103365b9.png";